<template>
  <div class="footerBox">
    <div class="foot_center">
      <div class="foot_tb">
        <div class="foot_left">
          <div class="foot_1">
            {{ lange == "ch" ? obj.footer.txt.ch : obj.footer.txt.en }}
          </div>
          <div class="foot_2">{{ obj.footer.htw }}</div>
          <div class="foot_3">
            <span
              >{{
                lange == "ch" ? obj.footer.eml.ch : obj.footer.eml.en
              }}
              info@easytimesip.com</span
            >
            <span
              >{{
                lange == "ch" ? obj.footer.tel.ch : obj.footer.tel.en
              }}
              {{
                lange == "ch" ? obj.footer.telnum.ch : obj.footer.telnum.en

              }}
              </span
            >
          </div>
          <div class="foot_4">
            {{ lange == "ch" ? obj.footer.adrs.ch : obj.footer.adrs.en
            }}{{ lange == "ch" ? obj.footer.adrc.ch : obj.footer.adrc.en }}
          </div>
        </div>
        <div class="foot_right">
          <img src="@/assets/images/erwema.png" />
          <span>
           <img src="@/assets/images/icon_police.png" />
           <span><a class="icpa" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102011487" target="_blank">{{
            lange == "ch" ? obj.footer.bnun.ch : obj.footer.bnun.en
            }}</a>
          </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      obj: {},
    };
  },
  created() {
    this.obj = this.$store.state.indexText;
  },
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footerBox {
  width: 100%;
  display: block;
  background-color: #3b414d;
}
  .icpa{
    color: #aaa;
    text-decoration:none;
  }
  .icpa:link {
    color: #aaa;
    text-decoration:none;
  }
  .icpa:visited {
    color: #aaa;
    text-decoration:none;
  }
.foot_center {
  width: 62.5%;
  display: block;
  margin: 0 auto;
  position: relative;
}
.foot_tb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 40px 0;
}
.foot_left {
  width: 50%;
  display: block;
}
.foot_1,
.foot_2,
.foot_3,
.foot_4 {
  width: 100%;
  display: block;
}
.foot_1 {
  font-size: 16px;
  color: #fff;
}
.foot_2 {
  font-size: 12px;
  color: #aaaaaa;
  margin: 10px 0 60px 0;
}
.foot_3 > span {
  margin: 0 10px 0 0;
  font-size: 14px;
  color: #bda67d;
}
.foot_4 {
  font-size: 14px;
  color: #bda67d;
  margin-top: 5px;
}
.foot_right {
  display: block;
}
.foot_right > img {
  width: 129px;
  height: 129px;
  display: block;
  margin: 0 auto;
}
.foot_right > span {
  width: 188px;
  display: block;
  font-size: 12px;
  color: #aaa;
  margin: 16px 0 0 0;
}
@media only screen and (max-width: 1440px) {
  .foot_center {
    width: 90%;
  }
}
@media only screen and (max-width: 425px) {
  .foot_left {
    width: 100%;
    display: block;
  }
  .foot_tb {
    flex-wrap: wrap;
    text-align: center;
    padding: 30px 0 0 0 ;
  }
  .foot_right {
    width: 40%;
    margin-top: 26px;
    margin-left: 32%;
    text-align: center;
  }
  .foot_right > img {
    width: 75%;
    height: auto;
    margin: 0% 0% 0% 12.5%;
  }
  .foot_right > span {
    width: 100%;
  }

  .foot_1 {
    font-size: 14px;
  }

  .foot_3 > span {
    display: block;
    font-size: 12px;
    line-height: 18px;
  }
  .foot_4 {
    font-size: 12px;
  }
  .foot_2 {
    margin: 8px 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue